import React from "react";
import { Discount, mapOtherClaimlessPolicyDiscountValues, OtherClaimlessPolicyDiscountTypes } from "../../../../helpers/discount";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import TextInput from "../../../sharedComponents/textInput/textInput";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";

interface OtherClaimlessPolicyDiscountProps {
  calculateStore?: CalculateStore;
}

export function OtherClaimlessPolicyDiscount(props: OtherClaimlessPolicyDiscountProps) {
  const otherClaimlessPolicyDiscountValues = props.calculateStore!.discounts.otherClaimlessPolicyDiscount.value;

  return (
    <div className="discount-wrapper discount-for-other-claims-free-policies">
      <div className="discount-label">
        {Discount.discountsConfiguration.otherClaimlessPolicyDiscount.label}
      </div>
      <div className="discount-inputs">
        <DropDown
          value={otherClaimlessPolicyDiscountValues.type}
          items={Discount.otherClaimlessPolicyDiscountDropDownValues}
          onChange={(newType: OtherClaimlessPolicyDiscountTypes) => {
            if (otherClaimlessPolicyDiscountValues.type !== newType) {
              props.calculateStore!.setOtherClaimlessPolicyDiscount(newType, otherClaimlessPolicyDiscountValues.value);
            }
          }} />

        <TextInput
          disabled={true}
          value={mapDiscount()}
        />
      </div>
    </div>
  );

  function mapDiscount() {
    const policyDiscount = props.calculateStore!.calculationResponse?.coverages.corrections?.claimlessPolicyClientDiscount ?? null;
    return mapOtherClaimlessPolicyDiscountValues(policyDiscount);
  }
}

export default inject("calculateStore")(observer(OtherClaimlessPolicyDiscount));
